// extracted by mini-css-extract-plugin
export default {"container":"Signin_container__V8zVl","form":"Signin_form__2HbzO","buttons":"Signin_buttons__ivzp8","pagechange":"Signin_pagechange__uQPlW","box":"Signin_box__tOm1m"};